export const REST_API_URL = "https://api.granhand.com";
export const KAKAO = {
  API_KEY: "841d28c89cfb2fb4d62744cd44dbfc13",
  SESSION_PATH: "/kakao/session",
  CALLBACK_PATH: "/kakao/callback",
};

export const NAVER = {
  AUTH_URL: "https://nid.naver.com/oauth2.0/authorize",
  CLIENT_ID: "aq2GwSBX93A1be7vdR_v",
  CALLBACK_PATH: "/naver/callback",
  SESSION_PATH: "/naver/session",
};

export const REST_GET_COUNTRY_PATH = "/geo/country";

export const LOG_IN_COOKIE = "log_in_cookie_granhand";

export const CAFE24_URL = "https://granhand.com";

export const GUEST_ORDER_URL_PATH =
  "/member/search_order.html?noMemberOrder&returnUrl=%2Fmyshop%2Forder%2Flist.html";
export const MY_SHOP_URL_PATH = "/myshop/index.html";

export const SSO_COOKIE = "sso_cookie_granhand";
